interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={isCenter ? "max-w-2xl mx-auto text-center" : "max-w-2xl"}>
      <span className="inline-flex items-center gap-2 text-xs font-label font-medium tracking-wide uppercase text-primary-700 bg-primary-100/70 border border-primary-200 rounded-full px-3 py-1">
        <span className="w-1.5 h-1.5 rounded-full bg-accent-500" aria-hidden="true" />
        {eyebrow}
      </span>
      <h2 className="mt-4 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
        {title}
      </h2>
      {desc ? (
        <p className="mt-3 text-foreground-600 text-sm md:text-base leading-relaxed">{desc}</p>
      ) : null}
    </div>
  );
}